import {Flex, Icon, ListItem, PriorityIcon, Text} from '@priority-software/priority-style-react';
import React from 'react';

import styles from './styles.module.scss';
import {MacroItem} from '../../../../Macro/types';

export type SubMenuItem = Partial<MacroItem>;

type Props = {
    item: SubMenuItem;
    onItemClick: (id) => void;
    index: number;
    currentFocusedIndex: number;
    handleEdit: (e, item: SubMenuItem) => void;
    handleDelete: (e, item: SubMenuItem) => void;
};

export const MacroDropdownItem = ({
    item,
    onItemClick,
    index,
    currentFocusedIndex,
    handleEdit,
    handleDelete
}: Props) => {
    return (
        <ListItem
            key={item.title}
            onClick={e => {
                e.stopPropagation();
                onItemClick(item);
            }}
            isFocused={currentFocusedIndex === index + 1}
            isActive={false}
            componentClasses={styles.subMenuItem}
        >
            <Flex justifyContent="flex-start">
                <Text tag="div" skin="label-1" componentClasses={styles.recordItem}>
                    {item.title}
                </Text>

                <Flex justifyContent="flex-end" componentClasses={styles.hoverItem}>
                    <Icon
                        componentClasses={styles.itemIcon}
                        icon={PriorityIcon.editFill}
                        onClick={e => handleEdit(e, item)}
                    />
                    <Icon
                        componentClasses={styles.itemIcon}
                        icon={PriorityIcon.delete}
                        onClick={e => handleDelete(e, item)}
                    />
                </Flex>
            </Flex>
        </ListItem>
    );
};
